import Base from "./BaseTemplate";
import React from "react";

export default function ErrorPage() {


    return (
        <Base>
            <div className="centerText">
                <h1>
                    404 Page Not Found
                </h1>
                <br />
                <p style={{ margin: "0" }}>The page you are looking for does not exist.</p>
                <p>If you believe this is an error, please contact jjiteam@googlegroups.com.</p>
            </div>
        </Base>
    )
}